// Note: do not use ghost-comments as that makes the #ghost-comments scrolling unreliable because we inject this div after page load!
export const ROOT_DIV_ID = 'ghost-comments-root';

// Note: 渡邉雄太本人のアカウントの識別子として使用します
export const YUTAWATANABE_NAME = '渡邊雄太';
